<template>
  <div class="checker-results">
    <div class="full">
      <h3>Vessel Name</h3>
      <div>{{ vesselName }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
      <h3>Registration Number</h3>
      <div>{{ registrationNumber }}</div>
    </div>
    <div class="half">
      <h3>Registration Expiry</h3>
      <div>{{ registrationExpiry }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
      <h3>Vessel Type</h3>
      <div>{{ vesselType }}</div>
    </div>
    <div class="half">
      <h3>Length</h3>
      <div>{{ vesselLength }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
      <h3>Manufacturer</h3>
      <div>{{ manufacturer }}</div>
    </div>
    <div class="half">
      <h3>Colour</h3>
      <div>{{ colour }}</div>
    </div>
    <div class="gap"></div>
  </div>
</template>
<script>
import { date, title, metres } from '@/filters'
export default {
  props: {
    item: { type: Object, default: {} }
  },
  computed: {
    registrationNumber () { return this.item.pc_rego_no },
    vesselType () { return title(this.item.pc_class_code) },
    vesselName () { return title(this.item.name || '') },
    vesselLength () { return metres(this.item.pc_length) },
    manufacturer () { return title(this.item.pc_hull_make || '') },
    colour () { return title(this.item.pc_colour || '') },
    registrationExpiry () { return date(this.item.pc_expiry_date) }
  },
  mounted () {
    if (window.__gaTracker) {
      window.__gaTracker('send', 'event', 'Licence Checker', 'Vessel Registration Check')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vessel-results.vue